<template>
  <div
    :id="gallery_id">
    <gallery-item
      v-for="(image, key) in get_images"
      :key="key"
      ref="gallery_item"
      :image_src="image.image_src"
      :image_src_lazy="image.image_lazy_src"
      :gallery_src="image.gallery_image"/>
  </div>
</template>

<script>
import PhotoSwipeLightbox from 'photoswipe/lightbox';
import GalleryItem from "./GalleryItem.vue";
import ssr, {ssr_window} from "../../../helpers/ssr";

export default {
  name: 'Gallery',
  components: {GalleryItem},
  mixins: [ssr],
  props: {
    images: {
      required: true,
      type: Array,
      default: () => []
    },
  },
  data() {
    return {
      lightbox: null
    }
  },
  computed: {
    gallery_id() {
      return `grid_gallery-${this._uid}`
    },
    get_images() {
      return this.images
    }
  },
  mounted() {
    ssr_window.addEventListener('scroll', this.scrollEvent)
    this.scrollEvent()
  },
  methods: {
    scrollEvent() {
      let {top} = this.$el.getBoundingClientRect()
      if((top - this.window_innerHeight) < 0) {
        this.initLightBox()
        this.destroyScrollEvent()
      }
    },
    destroyScrollEvent() {
      this.destroyResizeEvent()
      ssr_window.removeEventListener('scroll', this.scrollEvent)
    },
    initLightBox() {
      if (this.lightbox) return
      this.lightbox = new PhotoSwipeLightbox({
        gallery: `#${this.gallery_id}`,
        children: 'a.gallery__item',
        bgOpacity: 0.6,
        zoom: false,
        showHideAnimationType: 'fade',
        pswpModule: () => import('photoswipe'),
      });
      if (this.$refs.gallery_item?.length) {
        this.$refs.gallery_item.forEach(component => {
          component.calculateSize()
        })
      }
      this.lightbox.init();
    },
  },
  beforeDestroy() {
    if (!this.lightbox) return
    this.lightbox.destroy();
    this.lightbox = null;
    this.destroyScrollEvent()
  },
}
</script>
